import PropTypes from 'prop-types';

import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

import { useOffSetTop } from 'src/hooks/use-off-set-top';

import { bgBlur } from 'src/theme/css';

import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';

import { HEADER } from '../config-layout';
import HeaderShadow from './header-shadow';
import AccountPopover from './account-popover';
import SettingsButton from './settings-mode-button';

// ----------------------------------------------------------------------

/**
 * @param {Object} props
 * @param {boolean} [props.showAccount] - show the account menu
 * @param {string} [props.title] - the page's name, shown beside the logo ("Help center")
 * @param {string} [props.backTo] - where "Back to Voolist" leads, when the page offers a way back
 */
export default function HeaderSimple ({ showAccount = false, title, backTo }) {
  const theme = useTheme();

  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

  return (
    <AppBar>
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Logo />
          {title && (
            <Typography variant="subtitle1" component="span" sx={{ color: 'text.primary' }}>
              {title}
            </Typography>
          )}
        </Stack>

        <Stack direction="row" alignItems="center" spacing={1}>
          {backTo && (
            <Link
              component={RouterLink}
              href={backTo}
              aria-label="Back to Voolist"
              underline="none"
              sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, typography: 'body2', color: 'text.secondary', mr: 1 }}
            >
              <Iconify icon="solar:arrow-left-linear" width={18} />
              <Typography component="span" variant="body2" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                Back to Voolist
              </Typography>
            </Link>
          )}

          <SettingsButton />

          {showAccount && <AccountPopover />}

          {/* <Link
            href={paths.faqs}
            component={RouterLink}
            color="inherit"
            sx={{ typography: 'subtitle2' }}
          >
            Need help?
          </Link> */}
        </Stack>
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}

HeaderSimple.propTypes = {
  showAccount: PropTypes.bool,
  title: PropTypes.string,
  backTo: PropTypes.string,
};
